import { useApiQuery } from './useApiQuery';
import { sftpIpBlocksApi } from '@/api/sftpIpBlocks';
import type { SftpIpBlock } from '@/api/sftpIpBlocks';

interface UseSftpIpBlocksOptions {
  activeOnly?: boolean;
  enabled?: boolean;
}

export const useSftpIpBlocks = (options: UseSftpIpBlocksOptions = {}) => {
  const { activeOnly, enabled = true } = options;

  const { data, isLoading, error, isUsingMockData, reload } = useApiQuery<SftpIpBlock[]>(
    {
      queryFn: () => sftpIpBlocksApi.list(activeOnly),
      enabled,
    },
    [activeOnly],
  );

  return {
    ipBlocks: data ?? [],
    isLoading,
    error,
    isUsingMockData,
    reload,
  };
};
